import { IReduxState } from 'types/redux';

export const eventTypesListSelector = (state: IReduxState) => state.registry.eventTypes.typeMap;

export const messageFieldsSelector = (state: IReduxState) => state.registry.messageFields.typeMap;

export const attributeTypesSelector = (state: IReduxState) => state.registry.attributeTypes.codeMap;
